/**
 * @generated SignedSource<<b3f8ab82df27637909fcdd1713b75918>>
 * @relayHash faed0d2f1dd78a502a219a9a5d9dc53b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d4a419a258f4c5ca2db7e6708ac16a9abfa6d2a91dbdf3fc909766277682e0c0

import type { ConcreteRequest } from 'relay-runtime';
export type useUpdateContentPropertyBlogCreateMutation$variables = {
  blogPostId: string;
  propertyKey: string;
  propertyValue: string;
};
export type useUpdateContentPropertyBlogCreateMutation$data = {
  readonly confluence: {
    readonly createBlogPostProperty: {
      readonly blogPostProperty: {
        readonly id: string | null;
        readonly key: string;
        readonly value: string;
      } | null;
      readonly errors: ReadonlyArray<{
        readonly extensions: {
          readonly statusCode: number | null;
        } | null;
        readonly message: string | null;
      }> | null;
      readonly success: boolean;
    } | null;
  } | null;
};
export type useUpdateContentPropertyBlogCreateMutation = {
  response: useUpdateContentPropertyBlogCreateMutation$data;
  variables: useUpdateContentPropertyBlogCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "blogPostId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "propertyKey"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "propertyValue"
},
v3 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "blogPostId",
        "variableName": "blogPostId"
      },
      {
        "kind": "Variable",
        "name": "key",
        "variableName": "propertyKey"
      },
      {
        "kind": "Variable",
        "name": "value",
        "variableName": "propertyValue"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "success"
},
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = {
  "concreteType": "ConfluenceBlogPostProperty",
  "kind": "LinkedField",
  "name": "blogPostProperty",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    {
      "kind": "ScalarField",
      "name": "key"
    },
    {
      "kind": "ScalarField",
      "name": "value"
    }
  ]
},
v7 = {
  "kind": "ScalarField",
  "name": "message"
},
v8 = {
  "kind": "ScalarField",
  "name": "statusCode"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useUpdateContentPropertyBlogCreateMutation",
    "selections": [
      {
        "concreteType": "ConfluenceMutationApi",
        "kind": "LinkedField",
        "name": "confluence",
        "plural": false,
        "selections": [
          {
            "args": (v3/*: any*/),
            "concreteType": "ConfluenceCreateBlogPostPropertyPayload",
            "kind": "LinkedField",
            "name": "createBlogPostProperty",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v6/*: any*/),
              {
                "concreteType": "MutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  (v7/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "useUpdateContentPropertyBlogCreateMutation",
    "selections": [
      {
        "concreteType": "ConfluenceMutationApi",
        "kind": "LinkedField",
        "name": "confluence",
        "plural": false,
        "selections": [
          {
            "args": (v3/*: any*/),
            "concreteType": "ConfluenceCreateBlogPostPropertyPayload",
            "kind": "LinkedField",
            "name": "createBlogPostProperty",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v6/*: any*/),
              {
                "concreteType": "MutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  (v7/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__typename"
                      },
                      (v8/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v5/*: any*/)
                        ],
                        "type": "BulkMutationErrorExtension"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "faed0d2f1dd78a502a219a9a5d9dc53b",
    "id": "d4a419a258f4c5ca2db7e6708ac16a9abfa6d2a91dbdf3fc909766277682e0c0",
    "metadata": {},
    "name": "useUpdateContentPropertyBlogCreateMutation",
    "operationKind": "mutation",
    "text": "mutation useUpdateContentPropertyBlogCreateMutation($propertyKey:String!,$blogPostId:ID!,$propertyValue:String!){confluence{createBlogPostProperty(input:{key:$propertyKey,blogPostId:$blogPostId,value:$propertyValue}){success,blogPostProperty{id,key,value},errors{message,extensions{__typename,statusCode,...on BulkMutationErrorExtension{id}}}}}}"
  }
};
})();

(node as any).hash = "1ac5be7a6ec97ac06bb016be27c4c3a0";

export default node;
